<template>
    <page>
        <v-container fluid grid-list-md>
            <v-layout row wrap>
                <v-flex xs12>
                    <v-expansion-panels v-model="panel1" multiple>
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                <div>
                                    <v-icon>mdi-filter-variant</v-icon> Filters
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-card>
                                    <v-card-text>
                                        <v-flex xs12 sm6>
                                            <v-select v-model="form.printBy" :items="printByList" :label="labels.printBy"
                                                item-text="label" item-value="value" :data-vv-as="labels.printBy"
                                                v-validate="'required'" data-vv-name="form.printBy" />
                                        </v-flex>
                                        <v-layout row wrap>
                                        <v-flex xs12 sm6>
                                            <cal-picker v-model="form.reviewDateFrom" :label="labels.reviewDateFrom"
                                                :data-vv-as="labels.reviewDateFrom" data-vv-name="form.reviewDateFrom"
                                                :error-messages="errors.collect('form.reviewDateFrom')"
                                                v-validate="'required'" />
                                            </v-flex>
                                            <v-flex xs12 sm6>
                                            <cal-picker v-model="form.reviewDateTo" :label="labels.reviewDateTo"
                                                :data-vv-as="labels.reviewDateTo" data-vv-name="form.reviewDateTo"
                                                :error-messages="errors.collect('form.reviewDateTo')"
                                                v-validate="'required'" />
                                            </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                        <v-flex xs12 sm6>
                                            <v-select v-model="form.dri" :items="driList" :label="labels.dri" item-text="label" item-value="value" :data-vv-as="labels.dri" v-validate="'required'"
                                            data-vv-name="form.dri" />
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-text-field v-model="form.branch" :label="labels.branch" :error-messages="errors.collect('form.branch')" :data-vv-as="labels.branch" v-validate="'required'"
                                            data-vv-name="form.branch" append-icon="mdi-magnify" @click:append="showBranchHelpList=true" @click="showBranchHelpList=true" readonly/>
                                        </v-flex>
                                        </v-layout>
                                        <v-layout row wrap>
                                        <v-flex xs12 sm6>
                                            <v-text-field v-model="form.dept" :label="labels.dept" :error-messages="errors.collect('form.dept')" :data-vv-as="labels.dept" v-validate="'required'"
                                            data-vv-name="form.dept" append-icon="mdi-magnify" @click:append="showDeptHelpList=true" @click="showDeptHelpList=true" readonly/>
                                        </v-flex>
                                        <v-flex xs12 sm6>
                                            <v-text-field v-model="form.polType" :label="labels.polType" :error-messages="errors.collect('form.polType')" :data-vv-as="labels.polType" v-validate="'required'"
                                            data-vv-name="form.polType" append-icon="mdi-magnify" @click:append="showPolTypeHelpList=true" @click="showPolTypeHelpList=true" readonly/>
                                        </v-flex>
                                    </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-flex>
            </v-layout>
            <v-flex xs12>
            <v-expansion-panels v-model="panel2" multiple>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon>  Report Sequence
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <sort-order-table-basic :columns="columns" :headers="headers" :sortedListContainer="sortedListContainer" />
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            </v-expansion-panels>
            </v-flex>
            <v-flex xs12>
              <v-checkbox
                      :label="labels.pbPrtParam"
                      v-model="form.pbPrtParam"
                      :error-messages="errors.collect('pbPrtParam')"
                      data-vv-name="pbPrtParam"
                      :data-vv-as="labels.pbPrtParam"
                    />
                  </v-flex>
              <v-flex xs12 class="pt-3">
              <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
                {{ labels.export }}
                <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
              </v-btn>
              <v-btn-toggle dense mandatory v-model="form.format">
                <v-btn flat v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{ format.label }}</span>
                <v-icon :color="format.color">{{ format.icon }}</v-icon>
              </v-btn>
              </v-btn-toggle>
            </v-flex>
        </v-container>
        <v-dialog v-model="showBranchHelpList" width="900px" persistent>
            <multi-branch-help-list :brn="form.branch" @close="doClose" @doAssign="doAssignBranch($event)" />
        </v-dialog>
        <v-dialog v-model="showDeptHelpList" width="900px" persistent>
            <multi-dept-help-list :dept="form.dept" @close="doClose" @doAssign="doAssignDept($event)" />
        </v-dialog>
        <v-dialog v-model="showPolTypeHelpList" width="900px" persistent>
            <multi-pol-type-help-list :pt="form.polType" @close="doClose" @doAssign="doAssignPolType($event)" />
        </v-dialog>
    </page>
</template>
<script>
import MessageMixin from '@/mixins/message'
import MultiBranchHelpList from '../../../core/common/dialog/MultiBranchHelpList.vue'
import MultiDeptHelpList from '@/components/core/common/dialog/MultiDeptHelpList.vue'
import MultiPolTypeHelpList from '@/components/core/common/dialog/MultiPolTypeHelpList'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import SortOrderTableBasic from '@/components/reusable/SortOrderTableBasic'
export default {
  mixins: [
    MessageMixin
  ],
  components: {
    MultiBranchHelpList,
    MultiPolTypeHelpList,
    MultiDeptHelpList,
    SortOrderTableBasic
  },
  data() {
    return {
      menu: {},
      showBranchHelpList: false,
      showDeptHelpList: false,
      showPolTypeHelpList: false,
      submitting: false,
      form: {
        printBy: 'N',
        reviewDateFrom: new Date(),
        reviewDateTo: new Date(),
        dri: 'B',
        branch: 'All',
        dept: 'All',
        polType: 'All',
        pbPrtParam: false,
        format: 'PDF'
      },
      labels: {
        printBy: 'Print By',
        reviewDateFrom: 'Review Date From',
        reviewDateTo: 'Review Date To',
        dri: 'Direct / RI / Both',
        sortOrder: 'Report Sequence',
        branch: 'Branch',
        dept: 'Department',
        polType: 'Policy Type',
        pbPrtParam: 'Print Run Time Parameters',
        export: 'EXPORT TO'
      },
      printByList: [
        { label: 'N - Next Review Date', value: 'N' },
        { label: 'L - Last Review Date', value: 'L' }
      ],
      driList: [
        { label: 'D - Direct', value: 'D' },
        { label: 'R - Reinsurance', value: 'R' },
        { label: 'B - Both', value: 'B' }
      ],
      columns: [
        { label: 'Branch', value: 'branch' },
        { label: 'Department', value: 'dept' },
        { label: 'Direct/RI', value: 'dri' },
        { label: 'Last Review Date', value: 'lstRevDate' },
        { label: 'Next Review Date', value: 'nxtRevDate' },
        { label: 'Policy Type', value: 'polType' }
      ],
      headers: [
        { label: 'Sub Total', value: 'subTotal' },
        { label: 'Page Break', value: 'pageBreak' }
      ],
      sortedListContainer: {
        sortedList: []
      },
      supportedFormat: [],
      panel1: [0],
      panel2: []
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map((format) => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      try {
        if (this.$store.state.reports.claimReports.init !== 1) {
          await this.$store.dispatch('claimReportsInit')
        }
        const apiURI = this.$store.state.reports.claimReports.menu.clmNxtLastRevDate
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      if (this.sortedListContainer.sortedList.length === 0) {
        this.$toast.error('Please select sort columns.')
        return
      }
      for (let i = 0; i < this.sortedListContainer.sortedList.length; i++) {
        if ((this.form.printBy === 'N' && this.sortedListContainer.sortedList[i].value === 'lstRevDate') || (this.form.printBy === 'L' && this.sortedListContainer.sortedList[i].value === 'nxtRevDate')) {
          this.$toast.error('The value of the Print By must be same with the value of sort list.')
          return
        }
      }
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.export
      if (apiURI) {
        this.form.sort = this.sortedListContainer.sortedList
        this.form.cDesc = this.sortedListContainer.cDescList
        try {
          this.submitting = true
          this.form.sort = this.sortedListContainer.sortedList
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doClose() {
      this.showMultiReportSequence = false
      this.showBranchHelpList = false
      this.showDeptHelpList = false
      this.showPolTypeHelpList = false
    },
    async doAssignReportSeq(obj) {
      this.form.reportSeq = []
      this.form.reportSeq = obj.finalSelectedItems.toString()
    },
    async doAssignBranch(obj) {
      this.form.branch = []
      this.form.branch = obj.finalSelectedItems.toString()
    },
    async doAssignPolType(obj) {
      this.form.polType = []
      this.form.polType = obj.finalSelectedItems.toString()
    },
    async doAssignDept(Obj) {
      this.form.dept = []
      this.form.dept = Obj.finalSelectedItems.toString()
    }
  }
}
</script>
